import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass($options.classes),
    style: _normalizeStyle($options.style)
  }, [
    _createTextVNode(_toDisplayString($props.label) + " ", 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 6))
}